var app = angular.module('leonardo');

var ReportService = function (PermissionService, AuthDataService, $rootScope) {
  var service = {};

  service.title_quick = '';
  service.isDetailsView = false;

  service.setTitleQuick = function (title) {
    service.title_quick = title;
  };

  service.getTitleQuick = function () {
    return service.title_quick;
  };

  service.setQuickReport = function (report) {
    service.quick_report = report;
  };

  service.getQuickReport = function () {
    return service.quick_report;
  };

  service.removeQuickReport = function () {
    service.quick_report = null;
  };

  service.setDetailsView = function (detailView) {
    service.isDetailsView = detailView;
  };

  service.getDetailsView = function () {
    return service.isDetailsView;
  };

  // Constants
  service.STATUS_PENDING = '0';
  service.STATUS_SOLVED = '1';
  service.STATUS_CANNOT_DO = '2';
  service.STATUS_DISMISS = '3';
  service.STATUS_APPROVAL_REJECTED = '9';

  service.STATUS_OPTIONS = [
    {
      id: service.STATUS_PENDING,
      label: 'Incomplete'
    },
    {
      id: service.STATUS_SOLVED,
      label: 'Complete'
    },
    {
      id: service.STATUS_CANNOT_DO,
      label: 'Cannot Do'
    },
    {
      id: service.STATUS_APPROVAL_REJECTED,
      label: 'Terminated'
    }
  ];

  service.TYPE_ACTION_ITEM = '0';
  service.TYPE_ACTIVITY = '1';
  service.TYPE_WORKFLOW = '2';
  service.TYPE_DYNAMIC_FORM = '3';
  service.TYPE_BILLING = '4';
  service.TYPE_TEMPLATE = '5';
  service.TYPE_PROPERTY = '6';
  service.TYPE_USER = '7';
  service.TYPE_UNIT = '8';
  service.TYPE_ON_DEMAND_INSTRUCTION = '9';
  service.TYPE_EXISTING_DOCUMENTS = '10';
  service.TYPE_MISSING_DOCUMENTS = '11';
  service.TYPE_PROPERTY_AMENITIES = '12';
  service.TYPE_WORK_ORDERS = '13';
  service.TYPE_DYNAMIC_FORM_STATISTIC = '14';
  service.TYPE_CONTACT = '15';
  service.TYPE_MIMO = '16';
  service.TYPE_WORK_ORDER_ACTIVITY = '17';

  service.TYPE_OPTIONS = [];

  service.initTypes = function () {
    service.TYPE_OPTIONS = [
      {
        id: service.TYPE_ACTION_ITEM,
        name: 'Action Item'
      },
      {
        id: service.TYPE_PROPERTY_AMENITIES,
        name: 'Property Attributes'
      },
      {
        id: service.TYPE_ACTIVITY,
        name: 'User Activity'
      },
      {
        id: service.TYPE_UNIT,
        name: 'Unit Workflow'
      },
      {
        id: service.TYPE_WORKFLOW,
        name: 'Workflow'
      },
      {
        id: service.TYPE_DYNAMIC_FORM,
        name: 'Dynamic Form'
      },
      {
        id: service.TYPE_DYNAMIC_FORM_STATISTIC,
        name: 'Dynamic Form Statistics'
      },
      {
        id: service.TYPE_EXISTING_DOCUMENTS,
        name: 'Existing Documents'
      },
      {
        id: service.TYPE_MISSING_DOCUMENTS,
        name: 'Missing Documents'
      },
      {
        id: service.TYPE_ON_DEMAND_INSTRUCTION,
        name: 'On Demand Instruction'
      },
      {
        id: service.TYPE_CONTACT,
        name: 'Contact'
      }
    ];

    if (PermissionService.permissionAvailableAccount('permission_view_work_order')) {
      service.TYPE_OPTIONS.push({
        id: service.TYPE_WORK_ORDERS,
        name: 'Work Orders'
      });
    }

    if (PermissionService.permissionAvailableAccount('permission_view_reports_mimo')) {
      service.TYPE_OPTIONS.push({
        id: service.TYPE_MIMO,
        name: 'Move In / Move Out'
      });
    }

    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin() || PermissionService.permissionAvailable('permission_add_portfolio')) {
      service.TYPE_OPTIONS.push({ id: service.TYPE_PROPERTY, name: 'Property' });
    }

    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin() || AuthDataService.isWorkAsUser()) {
      service.TYPE_OPTIONS.push({ id: service.TYPE_TEMPLATE, name: 'Template Activity' });
    }
  };

  service.PRIORITY_MINOR = '0';
  service.PRIORITY_NORMAL = '1';
  service.PRIORITY_CRITICAL = '2';

  service.PRIORITY_OPTIONS = [
    {
      id: service.PRIORITY_CRITICAL,
      name: 'Critical'
    },
    {
      id: service.PRIORITY_NORMAL,
      name: 'Normal'
    },
    {
      id: service.PRIORITY_MINOR,
      name: 'Minor'
    }
  ];

  service.RECURRENCE_SCHEDULE_DAILY = '0';
  service.RECURRENCE_SCHEDULE_WEEKLY = '1';
  service.RECURRENCE_SCHEDULE_MONTHLY = '2';
  service.RECURRENCE_SCHEDULE_YEARLY = '3';

  service.RECURRENCE_SCHEDULE_OPTIONS = [
    {
      id: service.RECURRENCE_SCHEDULE_DAILY,
      name: 'Daily'
    },
    {
      id: service.RECURRENCE_SCHEDULE_WEEKLY,
      name: 'Weekly'
    },
    {
      id: service.RECURRENCE_SCHEDULE_MONTHLY,
      name: 'Monthly'
    },
    {
      id: service.RECURRENCE_SCHEDULE_YEARLY,
      name: 'Yearly'
    }
  ];

  service.LOOKUP_TYPE_EQ = '0';
  service.LOOKUP_TYPE_CONTAINS = '1';
  service.LOOKUP_TYPE_GT = '2';
  service.LOOKUP_TYPE_GTE = '3';
  service.LOOKUP_TYPE_LT = '4';
  service.LOOKUP_TYPE_LTE = '5';
  service.LOOKUP_TYPE_HAS_KEYS = '8';

  service.LOOKUP_TYPES = [
    {
      id: service.LOOKUP_TYPE_EQ,
      name: 'Equals'
    },
    {
      id: service.LOOKUP_TYPE_CONTAINS,
      name: 'Contains'
    },
    {
      id: service.LOOKUP_TYPE_GT,
      name: 'Greater'
    },
    {
      id: service.LOOKUP_TYPE_GTE,
      name: 'Greater or Equals'
    },
    {
      id: service.LOOKUP_TYPE_LT,
      name: 'Less'
    },
    {
      id: service.LOOKUP_TYPE_LTE,
      name: 'Less or Equals'
    },
    {
      id: service.LOOKUP_TYPE_HAS_KEYS,
      name: 'Contains'
    }
  ];

  service.CONDITION_OR = '0';
  service.CONDITION_AND = '1';

  service.CONDITIONS = [
    {
      id: service.CONDITION_OR,
      name: 'OR'
    },
    {
      id: service.CONDITION_AND,
      name: 'AND'
    }
  ];

  service.REPORT_TYPE_PHASE = '0';
  service.REPORT_TYPE_STATUS = '1';
  service.REPORT_TYPE_UNIT_TYPE = '2';
  service.REPORT_TYPE_CONTRACTOR = '3';
  service.REPORT_TYPE_APPROVALS = '4';

  service.REPORT_UNIT_TYPES = [
    {
      id: service.REPORT_TYPE_PHASE,
      name: 'Phase'
    },
    {
      id: service.REPORT_TYPE_STATUS,
      name: 'Status'
    },
    {
      id: service.REPORT_TYPE_UNIT_TYPE,
      name: 'Unit type'
    },
    {
      id: service.REPORT_TYPE_CONTRACTOR,
      name: 'Contractor'
    },
    {
      id: service.REPORT_TYPE_APPROVALS,
      name: 'Approval'
    }
    //{
    //  id: service.REPORT_TYPE_REPLACEMENTS,
    //  name: 'Replacements'
    //}
  ];

  service.fieldsReport = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'property', name: 'Property' },
    { id: 'groups', name: 'Property Group' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'action_item', name: 'Action Item' },
    { id: 'building', name: 'Building Number' },
    { id: 'unit', name: 'Unit Number' },
    { id: 'unit_type', name: 'Unit Type' },
    { id: 'due_date', name: 'Due Date' },
    { id: 'completed_date', name: 'Date Completed' },
    { id: 'made_by', name: 'Completed By' },
    { id: 'snoozed_by', name: 'Snoozed By' },
    { id: 'priority', name: 'Priority' },
    { id: 'account_users_assigned', name: 'Assigned To' },
    { id: 'notes', name: 'Notes' },
    { id: 'cannot_do_notes', name: 'Cannot Do Notes' },
    { id: 'note_add_by', name: 'Note Added By' },
    { id: 'notes_important', name: 'Notes Important' },
    { id: 'notes_attachments', name: 'Notes Attachments' },
    { id: 'template_attachments', name: 'Template Attachments' },
    { id: 'times_completed', name: 'Num. Times Complete' },
    { id: 'completed_on_device', name: 'Completed On Device' },
    { id: 'completed_position', name: 'Completed Position' },
    { id: 'times_cannot_do', name: 'Num. Times Cannot Do' },
    { id: 'times_appeared', name: 'Num. Appeared' },
    { id: 'times_missed', name: 'Num. Times Incomplete' },
    { id: 'times_snoozed', name: 'Num. Times Snoozed' },
    { id: 'marked_dismiss', name: 'Marked Dismiss' },
    { id: 'cannot_do', name: 'Marked Cannot Do' },
    { id: 'dynamic_form', name: 'Form Completed' },
    { id: 'approval_log', name: 'Approval Log' },
    { id: 'revision_number', name: 'Revision' }
  ];

  service.fieldsStatisticReport = [
    { id: 'portfolio_id', name: 'System Portfolio ID'},
    { id: 'property_id', name: 'System Property ID' },
    { id: 'action_item_ids', name: 'System Tasks ID'},
    { id: 'inspection_id', name: 'Inspection ID' },
    { id: 'property_external_id', name: 'Property External ID' },
    { id: 'property', name: 'Property' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'unit', name: 'Unit' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'status', name: 'Workflow Status' },
    { id: 'inspected_by', name: 'Inspected By' },
    { id: 'name', name: 'Workflow' },
    { id: 'date_launched', name: 'Date Launched' },
    { id: 'date_completed', name: 'Date Completed' },
    { id: 'date_last_edit', name: 'Date Last Edited' },
    { id: 'total_forms', name: 'Total Forms' },
    { id: 'completed_forms', name: 'Completed Forms' },
    { id: 'cannot_do_forms', name: 'Cannot Do Forms' },
    { id: 'pending_forms', name: 'Pending Forms' },
    { id: 'total_workflow_questions', name: 'Total Workflow Questions' },
    { id: 'actual_total_questions', name: 'Actual Total Questions' },
    { id: 'questions_answered', name: 'Question Answered' },
    { id: 'answered_percentage', name: 'Answered %' },
    { id: 'max_workflow_score', name: 'Max Workflow Score' },
    { id: 'actual_max_score', name: 'Actual Max Score' },
    { id: 'final_score', name: 'Final Score' },
    { id: 'final_score_percentage', name: 'Final Score %' },
    { id: 'final_adjusted_score_percentage', name: 'Final Adjusted Score %' },
    { id: 'section_score', name: 'Section Score' },
    { id: 'section_status', name: 'Section Status' }
  ];

  service.fieldsReportWorkOrder = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'property', name: 'Property' },
    { id: 'pms_external_id', name: 'External ID' },
    { id: 'groups', name: 'Property Group' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'id', name: 'Workorder ID' },
    { id: 'type', name: 'Type' },
    { id: 'due_date', name: 'Due Date' },
    { id: 'completed_date', name: 'Date Completed' },
    { id: 'completed_by', name: 'Completed By' },
    { id: 'submitted_date', name: 'Submitted Date' },
    { id: 'created_by', name: 'Created By' },
    { id: 'account_users_assigned', name: 'Assigned To' },
    { id: 'notes', name: 'Notes' },
    { id: 'notes_attachments', name: 'Notes Attachments' },
    { id: 'access_notes', name: 'Access Notes' },
    { id: 'attachments', name: 'Attachments' },
    { id: 'unit', name: 'Unit' },
    { id: 'completed_on_device', name: 'Completed On Device' },
    { id: 'tenant_code', name: 'Tenant' },
    { id: 'requester_name', name: 'Requester Name' },
    { id: 'requester_email', name: 'Requester Email' },
    { id: 'requester_code', name: 'Requester Code' },
    { id: 'has_permission_to_enter', name: 'Permission to Enter' },
    { id: 'tenant_caused', name: 'Tenant Responsible' },
    { id: 'technician_notes', name: 'Technician Notes' },
    { id: 'problem_description_notes', name: 'Problem Description Notes' },
    { id: 'vendor_code', name: 'Vendor Code' },
    { id: 'resolution_time', name: 'Resolution Time' },
    { id: 'full_description', name: 'Full Description' },
    { id: 'room_code', name: 'Room Code' },
    { id: 'general_repairs', name: 'General Repairs' },
    { id: 'reason', name: 'Reason' },
    { id: 'scheduled_start', name: 'Scheduled Start' },
    { id: 'scheduled_finish', name: 'Scheduled Finish' },
    { id: 'updated_by', name: 'Last Modified By' },
    { id: 'floor_code', name: 'Floor Code' },
    { id: 'brief_description', name: 'Brief Description' },
    { id: 'real_start', name: 'Real Start' },
    { id: 'real_finish', name: 'Real Finish' },
    { id: 'requester_phone_number', name: 'Requester Phone Number' },
    { id: 'service_request_date', name: 'Created Date' },
    { id: 'modified', name: 'Last Modified Date' },
    { id: 'priority', name: 'Priority' },
    { id: 'status', name: 'Status' }
  ];

  service.fieldsReportActivity = [
    { id: 'account', name: 'Account' },
    { id: 'portfolios', name: 'Portfolios' },
    { id: 'properties', name: 'Properties' },
    { id: 'groups', name: 'Property Groups' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'name', name: 'Name' },
    { id: 'email', name: 'User Email' },
    { id: 'user_role', name: 'User Role' },
    { id: 'date_joined', name: 'Created Date' },
    { id: 'dates_active', name: 'Dates Active' },
    { id: 'num_days_activity', name: 'Num. Days Active' },
    { id: 'days_since_last_activity', name: 'Days Since Last Activity' },
    { id: 'last_activity', name: 'Last Activity' },
    { id: 'last_action', name: 'Last Action' },
    { id: 'users_report_to', name: 'Reports To' },
    { id: 'users_report_to_email', name: 'Reports To (Email)' }
  ];

  service.fieldsReportActivityAdmin = [
    { id: 'account', name: 'Account' },
    { id: 'portfolios', name: 'Portfolios' },
    { id: 'properties', name: 'Properties' },
    { id: 'groups', name: 'Property Groups' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'name', name: 'User' },
    { id: 'first_name', name: 'User First Name' },
    { id: 'email', name: 'User Email' },
    { id: 'user_role', name: 'User Role' },
    { id: 'dates_inactive', name: 'Dates Inactive' },
    { id: 'dates_inactive_count', name: 'Total Days Inactive' },
    { id: 'num_days_activity', name: 'Num. Days Active' },
    { id: 'days_since_last_activity', name: 'Days Since Last Activity' },
    { id: 'last_activity', name: 'Last Activity' },
    { id: 'last_action', name: 'Last Action' },
    { id: 'users_report_to', name: 'Reports To First Name' },
    { id: 'users_report_to_email', name: 'Reports To (Email)' }
  ];

  service.fieldsReportProperty = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'groups', name: 'Property Group' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'managers', name: 'Managers' },
    { id: 'name', name: 'Name' },
    { id: 'billing_email', name: 'Billing Email' },
    { id: 'last_activity', name: 'Last Activity' }
  ];

  service.fieldsReportContact = [
    { id: 'account', name: 'Account' },
    { id: 'portfolios', name: 'Portfolio' },
    { id: 'properties', name: 'Property' },
    { id: 'name', name: 'Contact Name' },
    { id: 'contact_type', name: 'Contact Type' },
    { id: 'title', name: 'Title' },
    { id: 'email', name: 'Contact Email' },
    { id: 'user', name: 'User' }
  ];

  service.fieldsReportMimo = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'property', name: 'Property' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'move_in_inspection_date', name: 'Move-in Inspection Date' },
    { id: 'move_out_inspection_date', name: 'Move-out Inspection Date' },
    { id: 'section', name: 'Section' },
    { id: 'inspection_item', name: 'Inspection Item' },
    { id: 'move_in_inspection_result', name: 'Move-in Inspection Result' },
    { id: 'move_out_inspection_result', name: 'Move-out Inspection Result' },
    { id: 'move_in_inspection_comments', name: 'Move-in Inspection Result Comments' },
    { id: 'move_out_inspection_comments', name: 'Move-out Inspection Result Comments' }
  ];

  service.fieldsReportPropertyAmenities = [
    { id: 'account', name: 'Account' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'groups', name: 'Property Group' },
    { id: 'city', name: 'City' },
    { id: 'type', name: 'Type' },
    { id: 'building_style', name: 'Building Style' },
    { id: 'business_services', name: 'Business Services' },
    { id: 'cleaning', name: 'Cleaning' },
    { id: 'name', name: 'Name' },
    { id: 'equipment', name: 'Equipment' },
    { id: 'services', name: 'Services' }
  ];

  service.fieldsReportUser = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'property', name: 'Property' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'groups', name: 'Property Group' },
    { id: 'managed_by', name: 'Managed By' },
    { id: 'name', name: 'Name' },
    { id: 'email', name: 'Email' },
    { id: 'user_role', name: 'User Role' },
    { id: 'last_activity', name: 'Last Activity' }
  ];

  service.fieldsReportOnDemandInstruction = [
    { id: 'account', name: 'Account' },
    { id: 'user_portfolios', name: 'Portfolio' },
    { id: 'user_properties', name: 'Property' },
    { id: 'user_groups', name: 'Property Group' },
    { id: 'user_name', name: 'Name' },
    { id: 'user_email', name: 'User Email' },
    { id: 'user_role', name: 'User Role' },
    { id: 'dates_access', name: 'Dates Access' },
    { id: 'last_access', name: 'Last Day Access' }
  ];

  service.fieldsDocumentsReport = [
    { id: 'account', name: 'Account' },
    { id: 'portfolio', name: 'Portfolio' },
    { id: 'property', name: 'Property' },
    { id: 'pms_external_id', name: 'PMS Property ID' },
    { id: 'groups', name: 'Property Group' },
    { id: 'name', name: 'Document Name' },
    { id: 'expiration', name: 'Expiration Date' },
    { id: 'created', name: 'Created Date' },
    { id: 'link', name: 'Link' },
    { id: 'expired', name: 'Expired' },
    { id: 'status', name: 'Status' },
    { id: 'note', name: 'Note' },
    { id: 'action_item', name: 'Action Item' },
    { id: 'type', name: 'Type' },
    { id: 'secure_share_url', name: 'Share Url' },
    { id: 'dynamic_form', name: 'Dynamic Form' },
    { id: 'locked', name: 'Locked' },
    { id: 'show_warning', name: 'Show Warning' }
  ];

  service.fieldsDynamicFormsReport = [
    { id: 'property_id', name: 'System Property ID' },
    { id: 'portfolio_id', name: 'System Portfolio ID' },
    { id: 'workflow_instance_id', name: 'System Workflow ID' },
    { id: 'action_item_id', name: 'System Task ID' },
    { id: 'property_name', name: 'Property Name' },
    { id: 'property_address', name: 'Property Address' },
    { id: 'pms_property_id', name: 'PMS Property ID' },
    { id: 'portfolio_name', name: 'Portfolio Name' },
    { id: 'inspected_by', name: 'User Completed' },
    { id: 'datetime_of_inspection', name: 'Date Completed' },
    { id: 'unit_building', name: 'Building' },
    { id: 'unit_number', name: 'Unit' },
    { id: 'unit_type', name: 'Unit Type' },
    { id: 'pdf_file', name: 'Linked PDF Report'}
  ];

  service.actionItemsIdFields = [
    { id: 'property_id', name: 'System Property ID' },
    { id: 'portfolio_id', name: 'System Portfolio ID' },
    { id: 'workflow_instance_id', name: 'System Workflow ID' },
    { id: 'action_item_id', name: 'System Task ID' },
  ];

  service.propertyIdFields = [
    { id: 'property_id', name: 'System Property ID' },
    { id: 'portfolio_id', name: 'System Portfolio ID' },
  ];

  service.filtersActionItem = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'report_users',
    'name',
    'category',
    'subcategory',
    'priority',
    'status',
    'snoozed',
    'notes_text',
    'notes_include',
    'notes_important',
    'recurrence_type',
    'fields_active',
    'completed_on_due',
    'not_past_due',
    'extra_fields'
  ];

  service.filtersActivity = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'account_user',
    'active',
    'fields_active',
    'role',
    'mia',
    'report_to'
  ];

  service.filtersBilling = [
    'ordering',
    'group_by',
    'report_title',
    'account_reports',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'id'
  ];

  service.filtersDocuments = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'name',
    'folder_name',
    'noticed',
    'expired_warning',
    'expired',
    'expired_from',
    'expired_to',
    'archive',
    'only_df',
    'fields_active'
  ];

  service.filtersDynamic = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'dynamic_form',
    'fields_active',
    'dynamic_filters',
    'workflow_name',
    'triggered_tasks',
    'extra_fields'
  ];

  service.filtersOnDemandInstruction = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'account_user',
    'user_role',
    'not_access',
    'on_demand_instruction',
    'on_demand_category'
  ];

  service.filtersPropertyAmenities = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'name',
    'fields_active',
    'levels',
    'lookup_filters',
    'working_days',
    'without_amenities',
    'extra_fields'
  ];

  service.filtersProperty = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'zero_activity_logged',
    'zero_notes_added',
    'levels',
    'fields_active',
    'extra_fields'
  ];

  service.filtersTemplate = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'user_activity_action_done',
    'category',
    'subcategory',
    'name',
    'status'
  ];

  service.filtersTemplateAdmin = [
    'ordering',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'user_activity_action_done',
    'category',
    'subcategory',
    'name',
    'status'
  ];

  service.filtersUser = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'sector',
    'user_name',
    'fields_active',
    'active',
    'idle'
  ];

  service.filtersContact = [
    'ordering',
    'account_reports',
    'report_title',
    'response_email_recipients',
    'name',
    'contact_type',
    'email',
    'title',
    'portfolio_reports',
    'property_reports'
  ];

  service.filtersMimo = [
    'ordering',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'from_date',
    'to_date',
    'date_range',
    'report_title',
    'response_email_recipients',
    'building',
    'unit_number',
    'unit',
    'unit_type'
  ];

  service.filtersWorkOrders = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'name',
    'status',
    'type',
    'category',
    'priority',
    'fields_active',
    'service_request_date',
    'action_item__due_date',
    'completed_date',
    'building',
    'unit_number',
    'created_from_date',
    'created_to_date',
    'created_date_range'
  ];

  service.filtersWorkFlow = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'with_deleted',
    'unit_report_type',
    'name',
    'unit',
    'unit__unit_type',
    'by_unit',
    'workflow'
  ];

  service.filtersStatistic = [
    'ordering',
    'group_by',
    'account_reports',
    'managed_by_reports',
    'group_reports',
    'portfolio_reports',
    'property_reports',
    'report_title',
    'response_email_recipients',
    'from_date',
    'to_date',
    'date_range',
    'orientation',
    'with_deleted',
    'fields_active',
    'name',
    'workflow',
    'status',
  ];

  service.defaultActionItemsFields = [
    'portfolio',
    'property',
    'action_item',
    'due_date',
    'completed_date',
    'priority',
    'notes'
  ];

  service.defaultFieldsReportPropertyAmenities = [
    'style',
    'working_days',
    'property_info',
    'property_address',
    'pets',
    'business_services',
    'services',
    'cleaning',
    'pool',
    'recreation_relaxation',
    'parking_storage',
    'equipment_vehicles',
    'physical_community_features',
    'parking',
    'hvac',
    'plumbing',
    'fire_life_safety',
    'software_technology',
    'asset_management_items',
    'affordable_housing',
    'climate_factors',
    'insurance',
   ];
 
   service.defaultFieldsReportProperty = [
    'name',
    'billing_email',
    'account',
    'portfolio',
    'managers',
    'property_managers',
    'last_activity'
  ];

  service.initTypes();

  $rootScope.$on('auth-data:updated', function () {
    service.initTypes();
  });

  return service;
};

app.factory('ReportService', ['PermissionService', 'AuthDataService', '$rootScope', ReportService]);
